import requirementsSelector from '../../AppointmentRequirementsSelector';
import { ReferringPhysicianView } from './ReferringPhysicianView';
import {
    changeReferringPhysician,
    trimPhysicianValue,
    trackSelectReferringPhysician,
} from './ReferringPhysicianActions';
import { connect } from 'react-redux';
import { REFERRING_PHYSICIAN_STATE_KEY } from '../../constants';

export function mapStateToProps(state) {
    const requirements = requirementsSelector(state);
    return {
        referringPhysician: requirements[REFERRING_PHYSICIAN_STATE_KEY].value,
        invalidMessage: requirements[REFERRING_PHYSICIAN_STATE_KEY].error,
    };
}

export const mapDispatchToProps = {
    trimPhysicianValue,
    onReferringPhysicianEntered: changeReferringPhysician,
    trackSelectReferringPhysician,
};

export const ReferringPhysicianConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReferringPhysicianView);
